import { getQueryString } from './functions/GetQueryString'
import { HTMLClosedOrNot } from './functions/TransverseQues'
import { isFoTon } from './functions/isFoTon'
import { GetRandomArray } from './functions/GetRandomArray'
import { GetArrDisorder } from './functions/GetArrDisorder'
import { isPC } from './functions/IsPC'
import { getWXSys } from './functions/getWXSys'
import { language } from './functions/language'

function html2string(html){
    return html.replace(/<\/?.+?>/g,"").trim();
}

function filterHtmlTag(html){
    var msg = html.replace(/<\/?[^>]*>/g, ''); //去除HTML Tag
    msg = msg.replace(/[|]*\n/, '') //去除行尾空格
    msg = msg.replace(/&nbsp;/ig, ''); //去掉nbsp
    return msg;
}

function scrollTopAnimation(target_el,parent_el,offset) {
    let scrolltopTemp = parent_el.scrollTop;
    let rect = target_el.getBoundingClientRect();
    // 获取元素相对窗口的top值，此处应加上页面本身的偏移
    let top = scrolltopTemp + rect.top + offset;
    let currentTop = scrolltopTemp;
    let requestId;

    let isTop = top > currentTop;

    function step () {
        if(isTop){
            currentTop += 30;
        }else{
            currentTop -= 30;
        }
        if ((isTop&&currentTop <= top)||(!isTop&&currentTop >= top)) {
            parent_el.scrollTo(0, currentTop);
            requestId = window.requestAnimationFrame(step);
        } else {
			parent_el.scrollTo(0, top);
            window.cancelAnimationFrame(requestId);
        }
    }
    window.requestAnimationFrame(step);
}

// 是否为json 格式
function isJSON(str) {
    if (typeof str == 'string') {
        try {
            var obj=JSON.parse(str);
            if(typeof obj == 'object' && obj ){
                return true;
            }else{
                return false;
            }
    
        } catch(e) {
            return false;
        }
    }
}

function sortQuestion(questionlist){
    let page = 1;
    let sort = 0;
    let result = [];
    for(let question of questionlist){
        if(question.questionsTypeId == 26){
            page = question.pageNumber
        }
        question.orders = ++sort;
        question.pageNumber = page;

        result.push({
            id:question.id,
            orders:sort,
            pageNumber:page
        })
    }
    return result; 
}

// 获取url上的参数
function getQueryStringhash(key) {
    let after = window.location.hash.split("?")[1];
    if (after) {
        let reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
        let r = after.match(reg);
        if (r != null) {
            return decodeURIComponent(r[2]);
        }
        else {
            return null;
        }
    }
}
// 获取时间
function GetDate(data) {
    if(!data) {
        let date = Date.parse(new Date()).toString()
        data = date.slice(0, 10)
    }
    let time = data + '000'
    var date = new Date(parseInt(time))
    let Y = date.getFullYear()
    let M =
      date.getMonth() + 1 < 10
        ? '0' + (date.getMonth() + 1)
        : date.getMonth() + 1
    let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
    let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
    let m =
      date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
    let s =
      date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    return `${Y}-${M}-${D} ${h}:${m}:${s}`
  }
  
//   清除标签 并把图片标签替换为'[图片]'
function htmlFormat(str){
    return str.toString().replace(/<img[^>]*>/g, '[图片]').replaceAll(/<[^>]+>/g,'')
}

/*
 * param str 要截取的字符串
 * param L 要截取的字节长度，注意是字节不是字符，一个汉字两个字节
 * return 截取后的字符串
 */
function cutStr(str,L){    
    var result = '',
        strlen = str.length, // 字符串长度
        chrlen = str.replace(/[^\x00-\xff]/g,'**').length; // 字节长度

    if(chrlen<=L){return str;}
    
    for(var i=0,j=0;i<strlen;i++){
        var chr = str.charAt(i);
        if(/[\x00-\xff]/.test(chr)){
            j++; // ascii码为0-255，一个字符就是一个字节的长度
        }else{
            j+=2; // ascii码为0-255以外，一个字符就是两个字节的长度
        }
        if(j<=L){ // 当加上当前字符以后，如果总字节长度小于等于L，则将当前字符真实的+在result后
            result += chr;
        }else{ // 反之则说明result已经是不拆分字符的情况下最接近L的值了，直接返回
            return result;
        }
    }
}

export default {
    html2string,
    filterHtmlTag,
    scrollTopAnimation,
    sortQuestion,
    isJSON,
    getQueryStringhash,
    GetDate,
    htmlFormat,
    cutStr,
    getQueryString,
    HTMLClosedOrNot,
    isFoTon,
    isPC,
    GetRandomArray,
    GetArrDisorder,
    getWXSys,
    language
}